import { StratNodesReq, StratNodesDef } from "../type/strat-nodes-def";

export class StratNodesAdapter {
  static toInputDTO(req: StratNodesReq): any {
    return {
      outcome_node: req.outcome_node,
    };
  }

  static toOutputDTO(res: any): StratNodesDef {
    return res;
  }
}
